import { useEffect, useState } from "react";
import { mediaRequest } from "./mediaApi";

const results = {
  connected: "YouTube channel connected and verified.",
  cancelled: "YouTube connection was cancelled. Your previous connection was kept.",
  "wrong-channel": "That was a different YouTube channel. Try again and choose the channel shown here. Your previous connection was kept.",
  permissions: "Google did not provide all required permissions. Reconnect and allow YouTube access.",
  failed: "YouTube could not be connected. Try again. Your previous connection was kept.",
};
export default function YouTubeConnection({ scope, handle }) {
  const [status, setStatus] = useState(null), [error, setError] = useState(""), [busy, setBusy] = useState(false);
  const [notice] = useState(() => results[new URLSearchParams(window.location.search).get("youtube")] || "");
  useEffect(() => {
    let active = true;
    setStatus(null); setError("");
    mediaRequest("oauth/status").then(value => { if (active) setStatus(value); }).catch(() => { if (active) setError("YouTube connection status could not be loaded."); });
    const url = new URL(window.location.href);
    if (url.searchParams.has("youtube")) { url.searchParams.delete("youtube"); window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash); }
    return () => { active = false; };
  }, [scope]);
  const connection = status?.connections?.[scope];
  async function connect() {
    setBusy(true); setError("");
    try { const { url } = await mediaRequest(`oauth/${scope}/connect`, {}, "post"); window.location.assign(url); }
    catch (failure) { setError(failure.message); setBusy(false); }
  }
  async function disconnect() {
    if (!window.confirm(`Disconnect ${handle} from this website? Existing videos on YouTube will remain available.`)) return;
    setBusy(true); setError("");
    try { await mediaRequest(`oauth/${scope}`, {}, "delete"); setStatus(await mediaRequest("oauth/status")); }
    catch (failure) { setError(failure.message); }
    finally { setBusy(false); }
  }
  return <section className="mediaOAuthNotice" aria-label="YouTube connection">
    <strong>{connection?.connected ? `YouTube connected: ${connection.channelTitle}` : "Connect your YouTube channel"}</strong>
    <p>{connection?.connected ? `${handle} is connected and its channel ID has been verified. Use Content → Upload Video to publish a saved video to this channel.` : `Connect ${handle} to authorize this channel. Choose this channel when Google asks which account or channel to use.`}</p>
    {notice && <p role="status">{notice}</p>}
    {error && <p role="alert">{error}</p>}
    {!status && !error && <p role="status">Checking connection…</p>}
    {status && !status.configured && <p>OAuth credentials still need to be configured on the backend.</p>}
    {status?.configured && <div className="mediaActions"><button type="button" disabled={busy} onClick={connect}>{busy ? "Please wait…" : connection?.connected ? "Reconnect YouTube" : "Connect YouTube"}</button>{connection?.connected && <button type="button" disabled={busy} onClick={disconnect}>Disconnect</button>}</div>}
    {error && !status && <button type="button" onClick={() => window.location.reload()}>Refresh connection status</button>}
  </section>;
}
